import tk from '../../http/requests/timekeeping/index.js'
import axios from '@/axios.js'
import state from '../state'
import { XIcon } from 'vue-feather-icons'
export default {
    addSegment({commit}, item) {
        return new Promise((resolve, reject) => {
            axios.post('/api/timekeeping', item)
              .then((response) => {
                commit('ADD_SEGMENT', Object.assign(item, {employeeFiledTimeSheetId: response.data.data.employeeFiledTimeSheetId}))
                resolve(response)
              })
              .catch((error) => { reject(error) })
        })
    }, 
    getAllSegment({commit}, payload){
        return new Promise((resolve, reject) => {
          axios.get('/api/timekeeping', { params : {
            sortBy: payload.sortBy,
            sortOrder: payload.sortOrder,
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize
        }})
          .then((response) => {
            commit("GET_ALL_SEGMENT", response.data.data)
            resolve(response)
          })
          .catch((error) => { return reject(error) })
        })
    },
   
    getScheduleByDate({commit}, payload){
      return new Promise((resolve, reject) => {
        tk.getCurrentScheduleByDate(payload.scheduleDate, payload.userId)
        .then((response) => {
          commit("CURRENT_SCHEDULE", JSON.stringify(response.data.data))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
    },
    getAllScheduleNotClosed({commit}, userId){
      return new Promise((resolve, reject) => {
       axios.get('/api/schedule/getallschedulenotclosed', { params : {
         userId: userId
       }})
        .then((response) => {
          commit("GETALLSCHEDULENOTCLOSED", JSON.stringify(response.data.data))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
    },
    getLatestSegments({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.get('/api/timekeeping/segmenttypeId', { params : {
          scheduleId: payload.scheduleId,
          segmentTypeId: payload.segmentTypeId
      }})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
    },
  
    
}